import { RootLayout } from './src/layouts';

export const wrapRootElement = ({ element }) => (
  <RootLayout>{element}</RootLayout>
);
